import { Doc } from "@/components/Doc/Doc";
import { LabelExplainer } from "@/components/LabelExplainer/LabelExplainer";
import { InputDollar } from "@/components/_pages/ModelPage/Sidebar/InputDollar";
import {
  sellerProvidedAccountRecAtom,
  sellerProvidedCashAtom,
  sellerProvidedInventoryAtom,
  sellerProvidedOtherCurrentAssetsAtom,
  sellerProvidedPrepaidExpensesAtom,
  sellerProvidedTotalAtom,
} from "@/financeModels/owasco/workingCapital";
import { toNumberOrNull } from "@/utils/math";
import { formatMoneyErase00Decimal } from "@/utils/moneyFormating";
import { Stack } from "@mantine/core";
import { useAtom, useAtomValue } from "jotai";
import { TbHeartHandshake } from "react-icons/tb";
import { ComputedResult } from "../../Sidebar/ComputedResult";

const Panel = () => {
  const [sellerProvidedCash, setSellerProvidedCash] = useAtom(
    sellerProvidedCashAtom,
  );

  const [sellerProvidedAccountRec, setSellerProvidedAccountRec] = useAtom(
    sellerProvidedAccountRecAtom,
  );

  const [sellerProvidedInventory, setSellerProvidedInventory] = useAtom(
    sellerProvidedInventoryAtom,
  );

  const [sellerProvidedPrepaidExpenses, setSellerProvidedPrepaidExpenses] =
    useAtom(sellerProvidedPrepaidExpensesAtom);

  const [
    sellerProvidedOtherCurrentAssets,
    setSellerProvidedOtherCurrentAssets,
  ] = useAtom(sellerProvidedOtherCurrentAssetsAtom);

  const sellerProvidedTotal = useAtomValue(sellerProvidedTotalAtom);

  return (
    <Stack gap={4}>
      <InputDollar
        value={toNumberOrNull(sellerProvidedCash) || ""}
        onChange={(value) => setSellerProvidedCash(toNumberOrNull(value))}
        label={
          <LabelExplainer
            label="Cash"
            explanation={
              <Doc path="@/docs/pages/model/working-capital/sidebar/seller-provided-cash.mdx" />
            }
          />
        }
      />
      <InputDollar
        value={toNumberOrNull(sellerProvidedAccountRec) || ""}
        onChange={(value) => setSellerProvidedAccountRec(toNumberOrNull(value))}
        label={
          <LabelExplainer
            label="Accounts Rec. (A/R)"
            explanation={
              <Doc path="@/docs/pages/model/working-capital/sidebar/seller-provided-accounts-rec.mdx" />
            }
          />
        }
      />
      <InputDollar
        value={toNumberOrNull(sellerProvidedInventory) || ""}
        onChange={(value) => setSellerProvidedInventory(toNumberOrNull(value))}
        label={
          <LabelExplainer
            label="Inventory"
            explanation={
              <Doc path="@/docs/pages/model/working-capital/sidebar/seller-provided-inventory.mdx" />
            }
          />
        }
      />
      <InputDollar
        value={toNumberOrNull(sellerProvidedPrepaidExpenses) || ""}
        onChange={(value) =>
          setSellerProvidedPrepaidExpenses(toNumberOrNull(value))
        }
        label={
          <LabelExplainer
            label="Prepaid Expenses"
            explanation={
              <Doc path="@/docs/pages/model/working-capital/sidebar/seller-provided-prepaid-expenses.mdx" />
            }
          />
        }
      />
      <InputDollar
        value={toNumberOrNull(sellerProvidedOtherCurrentAssets) || ""}
        onChange={(value) =>
          setSellerProvidedOtherCurrentAssets(toNumberOrNull(value))
        }
        label={
          <LabelExplainer
            label="Other Current Assets"
            explanation={
              <Doc path="@/docs/pages/model/working-capital/sidebar/seller-provided-other-current-assets.mdx" />
            }
          />
        }
      />

      <ComputedResult
        label={
          <LabelExplainer
            label="Total Seller-Provided WC"
            explanation={
              <Doc path="@/docs/pages/model/working-capital/sidebar/seller-provided-total.mdx" />
            }
          />
        }
        value={formatMoneyErase00Decimal(
          toNumberOrNull(sellerProvidedTotal) || 0,
        )}
      />
    </Stack>
  );
};

export const ModuleSellerProvidedWorkingCapital = {
  key: "Seller-Provided Working Capital",
  icon: <TbHeartHandshake />,
  control: "Seller-Provided Working Capital",
  panel: <Panel />,
};
